import type React from "react";

import { ReactQueryDevtools } from "react-query/devtools";
import { Navigate, BrowserRouter as ReactRouter, Route, Routes } from "react-router-dom";

import { AdminRoutes } from "routes/admin";
import { AdminBillingRoutes } from "routes/admin-billing";
import { CalendarRoutes } from "routes/calendar";
import { DashboardRoutes } from "routes/dashboard";
import { InvitationsRoutes } from "routes/invitations";
import { LibraryRoutes } from "routes/library";
import { LoginRoutes } from "routes/login";
import { MessagesRoutes } from "routes/messages";
import { NotificationsRoute } from "routes/notifications";
import { OnboardingRoutes } from "routes/onboarding";
import { PatientsRoutes } from "routes/patients";
import { SettingsRoutes } from "routes/settings";
import { SignupRoutes } from "routes/signup";
import { VideoCallRoute } from "routes/videocall";
import { VoiceCallRoute } from "routes/voicecall";
import { WikiRoutes } from "routes/wiki";
import { ProtectedRoute } from "shared/ProtectedRoute";
import { ContextProviders } from "utils/contexts/ContextProviders";
import { isTestRunning } from "utils/misc/isTestRunning";

import { PageViewTracker } from "./PageViewTracker";

export const Router: React.FC = () => {
  return (
    <ReactRouter>
      <PageViewTracker />
      <ContextProviders>
        <Routes>
          <Route
            path="dashboard/*"
            element={
              <ProtectedRoute path="/dashboard">
                <DashboardRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="patients/*"
            element={
              <ProtectedRoute path="/patients">
                <PatientsRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="calendar/*"
            element={
              <ProtectedRoute path="/calendar">
                <CalendarRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="messages/*"
            element={
              <ProtectedRoute path="/messages">
                <MessagesRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="settings/*"
            element={
              <ProtectedRoute path="/settings">
                <SettingsRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="library/*"
            element={
              <ProtectedRoute path="/library">
                <LibraryRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="onboarding/*"
            element={
              <ProtectedRoute path="/onboarding">
                <OnboardingRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="invitations/*"
            element={
              <ProtectedRoute path="/invitations">
                <InvitationsRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin-billing/*"
            element={
              <ProtectedRoute path="/admin-billing">
                <AdminBillingRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/*"
            element={
              <ProtectedRoute path="/admin">
                <AdminRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="wiki/*"
            element={
              <ProtectedRoute path="/wiki">
                <WikiRoutes />
              </ProtectedRoute>
            }
          />

          <Route path="signup/*" element={<SignupRoutes />} />
          <Route path="login/*" element={<LoginRoutes />} />
          <Route path="*" element={<Navigate to="dashboard" />} />
        </Routes>
        <VideoCallRoute />
        <VoiceCallRoute />
        <NotificationsRoute />
        {!isTestRunning() && <ReactQueryDevtools />}
      </ContextProviders>
    </ReactRouter>
  );
};
